import { useSelector } from "react-redux";
import InfiniteProgressBar from "./InfiniteProgressBar";

const MainComponentWrapper = (props) => {
  const uiNotifiCation = useSelector((state) => state.UiNotification);
  return (
    <>
      {(props.Loading || uiNotifiCation.loading) && <InfiniteProgressBar />}
      {props.children}
    </>
  );
};
export default MainComponentWrapper;
